import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react"
import LandingPage from './components/LandingPage';
import PredictionPage from './components/PredictionPage';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import VerifyEmail from './components/VerifyEmail';
import ForgotPassword from './components/ForgotPassword';
import ErrorPages from './components/ErrorPages';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Routes>
          {/* Main Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/predict" element={<PredictionPage />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/verify" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          
          {/* Error Routes */}
          <Route path="/error" element={<ErrorPages type="server" />} />
          
          {/* 404 - Catch all undefined routes */}
          <Route path="*" element={<ErrorPages type="404" />} />
        </Routes>
      </div>
      <Analytics />
    </Router>
  );
}

export default App;